import { useQuery } from '@hooks/reactQuery';

import { portalTasks } from '@store/selectors';
import { useAppSelector } from '@store/store';

import { getPortalTasks } from '@api/portalTasks';

import { extractQueryParams } from '@utils/common';

import { IItemsResponse } from '@interfaces/common/response';
import { IPortalTaskDTO } from '@interfaces/portal/dto/taskManagementDTO';

import { refetchOptions } from '@constants/common';
import { GET_PORTAL_TASKS } from '@constants/queryKeys';

interface IUseQueryPortalTasksReturned {
	isLoadingPortalTasks: boolean;
	countOfRecords: number;
	portalTasks: Array<IPortalTaskDTO>;
}

export const useQueryPortalTasks = (projectId?: string): IUseQueryPortalTasksReturned => {
	const {
		page,
		pageSize,
		searchValue,
		sortFieldName,
		sortDirection,
		status,
		priority,
		milestoneId,
		assignees,
	} = useAppSelector(portalTasks);

	const {
		data,
		isLoading,
		isFetching,
	} = useQuery<IItemsResponse<IPortalTaskDTO>>({
			queryKey: [
				GET_PORTAL_TASKS,
				{
					page,
					pageSize,
					searchValue,
					sortFieldName,
					sortDirection,
					status,
					priority,
					projectId,
					milestoneId,
					assignees,
				},
			],
			queryFn: extractQueryParams(getPortalTasks),
			enabled: [!!projectId],
			...refetchOptions,
		},
	);

	return {
		isLoadingPortalTasks: isLoading || isFetching,
		portalTasks: data?.items || [],
		countOfRecords: data?.count || 0,
	};
};
